module.exports = __webpack_public_path__ + "static/media/corporate-services-img52.0fe76288.jpg";